import React, {useContext} from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import CreateTwoToneIcon from "@material-ui/icons/CreateTwoTone";
import { TextField, InputLabel } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";

import UserContext from "../Contexts/UserContext";
import Web3 from "web3";

const Ticket = [
  {
    value: "1",
    label: "1"
  },
  {
    value: "2",
    label: "2"
  },
  {
    value: "3",
    label: "3"
  },
  {
    value: "4",
    label: "4"
  },
  {
    value: "5",
    label: "5"
  }
];

export default function Createevent() {
  const context = useContext(UserContext);

  const classes = useStyles();
  window.document.title = "Book Event";

  const [Tickets, setTicket] = React.useState(1);

  const handleChange = (event) => {
    setTicket(event.target.value);
  };

  const handleBuyTicket = () => {
    context?.buyTicket(Tickets);
  }


  return (
    <section>
      <div class={classes.Createevent}>
        <h1 class={classes.heading} >
        
         BOOK &nbsp;EVENT
        </h1>
      
      </div>
      <div class={classes.root}>
        <div class={classes.adj}>
          <h1 style ={{textAlign :"center" , margin :"2%", marginBottom:"4%",backgroundColor:"rgb(230, 204, 255,0.2)",padding:"2%",font:" italic bold 12px/30px Georgia, serif",fontSize:"2.5rem"}}>
            <i>Event Registration Dapp</i>
          </h1>
      <section class={classes.bg}>
          <p style={{fontSize:"1.3rem"}}>
            <div style={{ display: "flex" , marginLeft:"32%"}}>
              <p>
                <b>Event Details</b>{" "}
              </p>{" "}
              <p style={{ marginLeft: "9%" }}>Dappnovation Hackathon</p>
            </div>
          </p>
         
          <p style={{fontSize:"1.3rem"}}>
            <div style={{ display: "flex" , marginLeft:"32%"}}>
              <p>
                {" "}
                <b>Date </b>{" "}
              </p>{" "}
              <p style={{ marginLeft: "20%" }}> Sep 30 , 2021 </p>
            </div>
          </p>
         
          <p style={{fontSize:"1.3rem"}}>
            <div style={{ display: "flex" , marginLeft:"32%"}}>
              <p>
                {" "}
                <b>Ticket Price </b>{" "}
              </p>
              <p style={{ marginLeft: "11%" }}> {Web3.utils.fromWei(Web3.utils.toBN(context?.priceOfTicket), "ether")} ETH</p>
            </div>
          </p>
         
          <p style={{fontSize:"1.3rem"}}>
            <div style={{ display: "flex" , marginLeft:"32%"}}>
              <p>
                {" "}
                <b> Quota </b>
              </p>
              <p style={{ marginLeft: "18%" }}> {context?.quota}</p>
            </div>
          </p>
         
          <p style={{fontSize:"1.3rem"}}>
            <div style={{ display: "flex", marginLeft:"32%" }}>
              <p>
                {" "}
                <b> Registrants </b>{" "}
              </p>
              <p style={{ marginLeft: "12%" }}> {context?.numOfTicketSold}</p>
            </div>
          </p>
          </section>
          <br></br>
          <h1  style ={{textAlign :"center" , marginBottom: "4%",backgroundColor:"rgb(230, 204, 255,0.2)",padding:"2%",font:" italic bold 12px/30px Georgia, serif",fontSize:"2.5rem"}}> <i>Register For Event</i> </h1>
          <p style ={{marginLeft:"20%",fontSize:"1.3rem" }}> <b>Address :</b>  {context?.currentAccount}</p>
          <p style ={{marginLeft:"20%",fontSize:"1.3rem" }}> <b>Balance :</b> {Web3.utils.fromWei(Web3.utils.toBN(context?.ethBalance), "ether")} ETH</p>
          <form>
            <InputLabel style ={{marginLeft:"20%" ,fontSize:"1.5rem" }}><i>Select number of tickets to buy</i></InputLabel>
            <br/>
            <TextField
              style={{ width: "60% ", marginBottom: "4%" ,marginLeft:"20%"}}
              id="outlined-select-currency"
              select
              value={Tickets}
              onChange={handleChange}
              variant="outlined"
            >
              {Ticket.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {/*<p>Total : 0EH </p>*/}
            <div >
              <Button
                style={{
                  width: "15rem ",
                  margin: "3%" ,
                  padding :"1.5%",
                 marginLeft : "37%",
                 fontFamily: "Algerian,Lucida Console, Courier New, monospace",
                 fontSize:"1.3rem",
                 backgroundColor:"#d9b3ff"
                
                }}
                variant="contained"
              
              
                onClick={()=>{handleBuyTicket()}}
              >
               <b> Buy &nbsp;ticket</b>
              </Button>

        
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    background: "rgba(255, 255, 255, 0.9)",
    backgroundPosition: "center",
    padding: "24px",
    paddingBottom: "50px",
    borderRadius: "50px",
    margin: "6%",
    hieght: "100%"
  },

  input: {
    marginTop: "4%",
    width: "68%",
    marginBottom: "2%"
  },
  
  Createevent: {
    width: "80%",
    margin: "auto",
    marginTop: "24px",
    marginBottom: "24px"
  },
  heading: {
    color: "white",
    fontSize: "3.5rem",
    fontWeight: "900",
    margin: 0,
    padding: 0,
    marginTop: "10%",
    fontFamily : "Algerian,Comic Sans MS, Comic Sans, cursive",
    textShadow:" 2px 10px 4px #000000",
    textAlign:"center"
    
  },
  subHeading: {
    color: "white",
    fontSize: "1.8rem",
    padding: "0",
    margin: "0",
    marginBottom: "2rem"
  }
}));
